import React from "react";
import "./App.css";
import { AppContextProvider } from "./AppContext";
import AppKeyUpListener from "./AppKeyUpListener";
import BodyFrame from "./components/layout_page/BodyFrame";
import FooterBar from "./components/layout_page/FooterBar";
import NavBar from "./components/layout_page/NavBar";
import PageContentFrame from "./components/layout_page/PageContentFrame";
import AnalysisPage from "./components/pages/AnalysisPage";
import TipJarPage from "./components/pages/TipJarPage";
import AppErrorPopup from "./components/popups/AppErrorPopup";
import HelpPopup from "./components/popups/HelpPopup";
import MenuPopup from "./components/popups/MenuPopup";
import { LinkToTipJarPage } from "./constants/navUrlConstants";

interface Props {}
interface State {
  routeHash: string;
}

export default class App extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      routeHash: window.location.hash,
    };
  }
  renderPage = () => {
    const { routeHash } = this.state;
    if (routeHash === LinkToTipJarPage) return <TipJarPage />;
    else return <AnalysisPage />;
  };

  updateHash = () => {
    this.setState({
      routeHash: window.location.hash,
    });
  };

  componentDidMount() {
    window.addEventListener("hashchange", this.updateHash, false);
  }

  componentWillUnmount() {
    window.removeEventListener("hashchange", this.updateHash, false);
  }

  render() {
    return (
      <AppContextProvider>
        <AppKeyUpListener />
        <BodyFrame>
          <NavBar />
          <AppErrorPopup />
          <HelpPopup />
          <MenuPopup />
          <PageContentFrame>{this.renderPage()}</PageContentFrame>
          <FooterBar />
        </BodyFrame>
      </AppContextProvider>
    );
  }
}
